import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';

export default function SignOut() {
  const navigate = useNavigate();

  React.useEffect(() => {
    signOut().then(() => {
      navigate('/');
    });
  }, [navigate]);
}
